import {AbstractControl} from '@angular/forms';

export class PasswordValidation {

  static MatchFieldsFactory(field1, field2, errorName) {
    return (abstractControl: AbstractControl) => {
      const password = abstractControl.get(field1).value; // to get value in input tag
      const confirmPassword = abstractControl.get(field2).value; // to get value in input tag
      if (password !== confirmPassword) {
        const error = {};
        error[errorName] = true;
        return error;
      } else {
        return null;
      }
    };
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/validators/password-validation.ts